import { marked } from "marked";

marked.use({
  breaks: true,
  gfm: true,
});

const tableStyles = {
  table: "border-collapse: collapse; width: 100%; margin: 10px 0;",
  th: "border: 1px solid #ddd; padding: 8px; text-align: left; background-color: #f5f5f5; font-weight: bold;",
  td: "border: 1px solid #ddd; padding: 8px; text-align: left;",
};

export function markdownToHtml(markdown: string): string {
  let html = marked.parse(markdown) as string;

  html = html
    .replace(/<\/p>\n<p>/g, "<br><br>")
    .replace(/<\/?p>/g, "")
    .replace(/<table>/g, `<table style="${tableStyles.table}">`)
    .replace(/<th>/g, `<th style="${tableStyles.th}">`)
    .replace(/<th /g, `<th style="${tableStyles.th}" `)
    .replace(/<td>/g, `<td style="${tableStyles.td}">`)
    .replace(/<td /g, `<td style="${tableStyles.td}" `);

  return html.replace(/<a href=/g, '<a target="_blank" href=');
}
